export default __webpack_public_path__ + "static/media/joni-and-friends-logo-white.9bb2be6c.png";